/* ================================================

   GreenX — Auto-select first available color

   when planter changes

   Uses Florona theme's native variant-change event

   ================================================ */



(function () {



  function autoSelectFirstAvailableColor() {

    const colorSwatches = document.querySelectorAll(

      '.form-options-wrapper.color-swatches .color-swatch'

    );



    if (!colorSwatches.length) return;



    // Check if any visible + available color is already selected

    let anyChecked = false;

    colorSwatches.forEach(function (swatchWrap) {

      const input = swatchWrap.querySelector('input[type=radio]');

      if (!input || input.classList.contains('disabled')) return;

      const isHidden = window.getComputedStyle(swatchWrap).display === 'none';

      if (!isHidden && input.checked) {

        anyChecked = true;

      }

    });



    // Click first visible + available swatch if none selected

    if (!anyChecked) {

      for (let i = 0; i < colorSwatches.length; i++) {

        const swatchWrap = colorSwatches[i];

        const input = swatchWrap.querySelector('input[type=radio]');

        if (!input || input.classList.contains('disabled')) continue;

        const isHidden = window.getComputedStyle(swatchWrap).display === 'none';

        if (!isHidden) {

          input.click();

          break;

        }

      }

    }

  }



  function init() {

    // Wait for webvista to be available

    if (typeof webvista === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {

      setTimeout(init, 100);

      return;

    }



    // Subscribe to Florona's native variant-change event

    webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {

      const variant = event.data && event.data.variant;

      if (!variant) return;



      // Run after DOM updates with the new variant HTML

      setTimeout(autoSelectFirstAvailableColor, 200);

    });



    // Also listen directly on planter radio inputs as backup

    document.addEventListener('change', function (e) {

      const input = e.target;

      if (

        input.type === 'radio' &&

        input.name === 'Planter'

      ) {

        setTimeout(autoSelectFirstAvailableColor, 400);

      }

    });



    // Run on page load

    setTimeout(autoSelectFirstAvailableColor, 500);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }



  document.addEventListener('shopify:section:load', init);



})();



/* ================================================

   GreenX — Sticky Add to Cart Bar

   ================================================ */



(function () {



  function initStickyAtc() {

    const bar = document.querySelector('.gx-sticky-atc');

    if (!bar) return;



    const formId = bar.dataset.productForm;

    const realForm = formId ? document.getElementById(formId) : null;

    const stickyButton = bar.querySelector('.gx-sticky-atc-button');

    const stickyPrice = bar.querySelector('[id^="GxStickyAtcPrice-"]');



    // Find the real Add to Cart button inside the real form

    function getRealAddToCartButton() {

      if (!realForm) return null;

      return realForm.querySelector('.add-cart-button, [name="add"]');

    }



    // Click sticky button -> click real Add to Cart button

    if (stickyButton) {

      stickyButton.addEventListener('click', function () {

        const realButton = getRealAddToCartButton();

        if (realButton) {

          realButton.click();

        }

      });

    }



    // Show/hide sticky bar based on scroll position relative to real buy buttons

    const buyButtonsSection = document.querySelector('.product-info-buy-buttons');



    if (buyButtonsSection) {

      const observer = new IntersectionObserver(

        function (entries) {

          entries.forEach(function (entry) {

            if (entry.isIntersecting) {

              bar.classList.remove('is-visible');

            } else {

              // Only show when scrolled past (not before reaching it)

              const rect = entry.boundingClientRect;

              if (rect.top < 0) {

                bar.classList.add('is-visible');

              } else {

                bar.classList.remove('is-visible');

              }

            }

          });

        },

        { threshold: 0 }

      );

      observer.observe(buyButtonsSection);

    }



    // Keep sticky price synced with variant changes via Florona's variant-change event

    function syncPrice() {

      if (typeof webvista === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {

        setTimeout(syncPrice, 150);

        return;

      }

      webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {

        const variant = event.data && event.data.variant;

        if (!variant || !stickyPrice) return;



        if (variant.available === false) {

          if (stickyButton) {

            stickyButton.disabled = true;

            stickyButton.textContent = window.variantStrings ? window.variantStrings.soldOut : 'Sold out';

          }

        } else {

          if (stickyButton) {

            stickyButton.disabled = false;

            stickyButton.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Add to Cart';

          }

        }



        // Update displayed price from the real price element if available

        const realPriceEl = document.querySelector('.price__regular .price-item, .product-info .price-item--regular, .product-info .price .price-item');

        if (realPriceEl) {

          stickyPrice.textContent = realPriceEl.textContent.trim();

        }

      });

    }



    syncPrice();

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initStickyAtc);

  } else {

    initStickyAtc();

  }



  document.addEventListener('shopify:section:load', initStickyAtc);



})();

/* ── Auto-select first AVAILABLE variant on product page load ── */

(function () {

  function autoSelectAvailableVariant() {

    var variantSelector = document.querySelector('high-variant-selects[data-url]');

    if (!variantSelector) return;

 

    var productUrl = variantSelector.getAttribute('data-url');

    if (!productUrl) return;

 

    fetch(productUrl + '.js')

      .then(function(res) { return res.json(); })

      .then(function(product) {

        var variants = product.variants;

        if (!variants || !variants.length) return;

 

        var variantInput = document.querySelector('input[name="id"]');

        if (!variantInput) return;

 

        var currentId = parseInt(variantInput.value);

        var currentVariant = null;

        for (var i = 0; i < variants.length; i++) {

          if (variants[i].id === currentId) { currentVariant = variants[i]; break; }

        }

 

        if (!currentVariant || currentVariant.available) return;

 

        var firstAvailable = null;

        for (var j = 0; j < variants.length; j++) {

          if (variants[j].available) { firstAvailable = variants[j]; break; }

        }

        if (!firstAvailable) return;

 

        console.log('[GreenX] Auto-switching to first available variant:', firstAvailable.title);

 

        var optionValues = [firstAvailable.option1, firstAvailable.option2, firstAvailable.option3].filter(Boolean);

 

        optionValues.forEach(function(optVal) {

          var radios = variantSelector.querySelectorAll('input[type="radio"]');

          for (var k = 0; k < radios.length; k++) {

            var r = radios[k];

            if (r.value === optVal && !r.checked) {

              r.checked = true;

              r.dispatchEvent(new Event('change', { bubbles: true }));

              break;

            }

          }

          var selects = variantSelector.querySelectorAll('select');

          selects.forEach(function(sel) {

            for (var m = 0; m < sel.options.length; m++) {

              if (sel.options[m].value === optVal) {

                sel.value = optVal;

                sel.dispatchEvent(new Event('change', { bubbles: true }));

                break;

              }

            }

          });

        });

      })

      .catch(function(err) {

        console.log('[GreenX] Variant auto-select error:', err);

      });

  }

 

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function() {

      setTimeout(autoSelectAvailableVariant, 1000);

    });

  } else {

    setTimeout(autoSelectAvailableVariant, 1000);

  }

})();

/* ================================================
   GreenX Cart Discount Apply Button Permanent Delegation
   Survives all AJAX cart drawer re-renders & touch taps on mobile
   ================================================ */
(function() {
  window.toggleGreenX10 = function(btn) {
    if (!btn) return;
    if (btn.dataset.busy === "true") return;
    btn.dataset.busy = "true";

    var isCurrentlyApplied = btn.getAttribute('data-applied') === 'true';
    var code = isCurrentlyApplied ? '' : 'GREENX10';
    btn.innerHTML = isCurrentlyApplied ? 'Removing...' : 'Applying...';

    var container = btn.closest('cart-drawer, cart-items, .cart-details') || document;
    var drawer = btn.closest('cart-drawer');
    var sectionId = drawer ? drawer.getAttribute('data-section') : null;
    var modal = container.querySelector('cart-code-modal') || document.querySelector('cart-code-modal');

    var sessionUrl = isCurrentlyApplied ? '/discount/CLEAR' : '/discount/' + encodeURIComponent(code);
    fetch(sessionUrl, { credentials: 'same-origin' })
      .then(function() {
        if (modal && typeof modal.updateDiscount === 'function') {
          return modal.updateDiscount(code);
        } else {
          var updateUrl = (window.routes && window.routes.cart_update_url) ? window.routes.cart_update_url : '/cart/update.js';
          var sections = sectionId ? [sectionId] : [];
          return fetch(updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: code, sections: sections, sections_url: window.location.pathname })
          }).then(function(res) { return res.json(); }).then(function(parsedState) {
            if (drawer && parsedState.sections && sectionId && parsedState.sections[sectionId]) {
              var target = drawer.querySelector('#Cart-Drawer-Details');
              if (target) {
                var temp = document.createElement('div');
                temp.innerHTML = parsedState.sections[sectionId];
                var newDetails = temp.querySelector('#Cart-Drawer-Details');
                if (newDetails) {
                  target.innerHTML = newDetails.innerHTML;
                } else {
                  target.innerHTML = parsedState.sections[sectionId];
                }
              }
            } else {
              location.reload();
            }
          });
        }
      })
      .catch(function() {
        location.reload();
      })
      .finally(function() {
        if (btn) btn.dataset.busy = "false";
      });
  };

  function handleDiscountTap(e) {
    var btn = e.target.closest('#greenx10-apply-btn, .offer-apply-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof window.toggleGreenX10 === 'function') {
        window.toggleGreenX10(btn);
      }
    }
  }

  if (document.body) {
    document.body.addEventListener('click', handleDiscountTap, { capture: true });
    document.body.addEventListener('touchstart', handleDiscountTap, { passive: false, capture: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.addEventListener('click', handleDiscountTap, { capture: true });
      document.body.addEventListener('touchstart', handleDiscountTap, { passive: false, capture: true });
    });
  }
})();

/* ================================================
   GreenX — Global Direct Buy It Now Handler
   ================================================ */
(function() {
  function handleBuyNowGlobal(e) {
    var btn = e.target.closest(
      '.gx-buy-now-button, [data-buy-now-button], .shopify-payment-button__button, [data-testid="Checkout-button"], shopify-buy-it-now-button, .shopify-payment-button [role="button"]'
    );
    if (!btn) return;

    if (btn.dataset.handlingBuyNow === 'true') return;
    btn.dataset.handlingBuyNow = 'true';

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var sectionId = btn.getAttribute('data-section') || '';
    if (window.handleGxBuyNow && sectionId) {
      window.handleGxBuyNow(e, sectionId);
      return;
    }

    var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (quantity < 1) quantity = 1;

    btn.setAttribute('disabled', 'disabled');
    var textSpan = btn.querySelector('.button-text') || btn;
    if (textSpan && textSpan.textContent) {
      textSpan.textContent = 'Redirecting to checkout...';
    }

    var params = new URLSearchParams(window.location.search);
    var previewThemeId = params.get('preview_theme_id');
    var isEditor = (window.Shopify && window.Shopify.designMode) || (window.self !== window.top && !previewThemeId);
    var checkoutUrl = '/checkout';
    var fallbackUrl = '/cart/' + encodeURIComponent(variantInput.value) + ':' + encodeURIComponent(quantity);
    if (previewThemeId) {
      checkoutUrl += '?preview_theme_id=' + encodeURIComponent(previewThemeId);
      fallbackUrl += '?preview_theme_id=' + encodeURIComponent(previewThemeId);
    }

    var formData = new FormData();
    formData.append('id', variantInput.value);
    formData.append('quantity', quantity);

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(r) {
        var url = r.ok ? checkoutUrl : fallbackUrl;
        if (isEditor) {
          window.open(url, '_blank') || (window.location.href = url);
        } else {
          window.location.href = url;
        }
      })
      .catch(function() {
        if (isEditor) {
          window.open(fallbackUrl, '_blank') || (window.location.href = fallbackUrl);
        } else {
          window.location.href = fallbackUrl;
        }
      });
  }

  document.addEventListener('click', handleBuyNowGlobal, true);
  document.addEventListener('touchend', handleBuyNowGlobal, { passive: false, capture: true });
})();
